import React from "react"

type Props = {
  label: string
  selected: boolean
  onClick: () => void
}

const Pill = ({ label, selected, onClick }: Props) => {
  return (
    <button
      onClick={onClick}
      className={`${
        selected ? "bg-green-dark" : "bg-dark-light"
      } py-1 px-2 rounded-m`}
    >
      {selected && <i className="fa fa-check fa-xs"></i>}
      <span className="color-white mx-1 font-14">{label}</span>
    </button>
  )
}

export default Pill
